import { useState } from 'react';
import cn from 'classnames';
import type { PlatformCompany } from '../../../../types';
import type { CompanyRowDisplayFlags } from '../types';
import { HeaderBlock, ExportBlock, InsightBlock } from '../row-blocks';
import { MainProductBlock } from '../row-blocks/MainProductBlock';
import { SupplierDetailDrawer } from '../../supplier-detail/supplier-detail';

export interface GlobalCompanyCardProps {
  company: PlatformCompany;
  displayFlags: CompanyRowDisplayFlags;
  className?: string;
}

/**
 * GlobalCompanyCard — 全球平台（GLOBAL）供应商卡片
 *
 * 中部区块根据数据自动选择：
 * - 有 mainProducts → ProductBlock（产品图 + 产品名）
 * - 否则 → ExportBlock（主营产品文本 + 出口统计三列）
 *
 * 点击卡片（需 companyId 存在）可打开 SupplierDetailDrawer 侧弹窗查看详情。
 */
export function GlobalCompanyCard({ company, displayFlags, className }: GlobalCompanyCardProps) {
  const { showInsightSection } = displayFlags;
  const [drawerVisible, setDrawerVisible] = useState(false);

  const canOpenDetail = !!company.companyId;

  return (
    <>
      <div
        className={cn('bg-white rounded-lg p-3 h-full', canOpenDetail && 'cursor-pointer', className)}
        onClick={() => {
          if (canOpenDetail) setDrawerVisible(true);
        }}
      >
        {/* 区块1：头部 */}
        <HeaderBlock company={company} />
        {/* 主营商品 */}
        <MainProductBlock show={true} mainProduct={company.mainProducts} />
        {/* 出口记录 */}
        <ExportBlock show company={company} />

        {/* 水平分隔线 */}
        {showInsightSection && <div className="border-t border-[#F0F0F0] mt-[22px]" />}

        {/* 区块5：AI 洞察 */}
        <InsightBlock show={showInsightSection} aiInsight={company.aiInsight} />
      </div>

      <SupplierDetailDrawer
        traceId="search_company_detail_view"
        isAiSummaryLoding={false}
        visible={drawerVisible}
        companyId={company.companyId ?? undefined}
        supplier={null}
        detailedSellingPoint={company.aiInsight ?? undefined}
        onClose={() => setDrawerVisible(false)}
      />
    </>
  );
}
